export enum OperationTypeEnum {
  STANDARD = "Padrão",
  RENEWAL = "Renovação",
  BRING_YOUR_OWN = "Permite linha externa"
}

export enum OperationType {
  STANDARD = "STANDARD",
  RENEWAL = "RENEWAL",
  BRING_YOUR_OWN = "BRING_YOUR_OWN"
}

export enum LineStrategyType {
  MANUALLY_SELECTED_LINE = "MANUALLY_SELECTED_LINE",
  MANUALLY_TYPED_LINE = "MANUALLY_TYPED_LINE",
  MANUALLY_TYPED_LINE_AND_SEARCH_SOLD = "MANUALLY_TYPED_LINE_AND_SEARCH_SOLD",
  MANUALLY_TYPED_LINE_AND_SEARCH_REMOVED = "MANUALLY_TYPED_LINE_AND_SEARCH_REMOVED",
  MANUALLY_TYPED_LINE_AND_SEARCH = "MANUALLY_TYPED_LINE_AND_SEARCH",
  RANDOM_LINE_SEARCH = "RANDOM_LINE_SEARCH",
  VIRTUAL_LINE = "VIRTUAL_LINE",
  NO_LINE = "NO_LINE",
  MANUALLY_SELECTED_LINE_PRE = "MANUALLY_SELECTED_LINE_PRE",
  PRE_LINE_SEARCH_FIFO = "PRE_LINE_SEARCH_FIFO"
}

/**
 * Estratégias de linha que não requerem seleção/inserção de número pelo usuário.
 * O sistema atribui a linha automaticamente via algoritmo ou não necessita de linha.
 */
export const LINE_STRATEGIES_WITHOUT_PHONE_SELECTION: readonly LineStrategyType[] =
  [
    LineStrategyType.NO_LINE,
    LineStrategyType.VIRTUAL_LINE,
    LineStrategyType.RANDOM_LINE_SEARCH,
    LineStrategyType.PRE_LINE_SEARCH_FIFO
  ];

export enum LineStrategyEnum {
  MANUALLY_SELECTED_LINE = "Seleção",
  MANUALLY_TYPED_LINE = "Inserção Manual",
  MANUALLY_TYPED_LINE_AND_SEARCH_SOLD = "Inserção Manual e Busca linha vendida",
  MANUALLY_TYPED_LINE_AND_SEARCH_REMOVED = "Inserção Manual e Busca linha externa",
  MANUALLY_TYPED_LINE_AND_SEARCH = "Inserção Manual e Busca linha",
  RANDOM_LINE_SEARCH = "Linha Aleatória",
  VIRTUAL_LINE = "Linha Virtual",
  NO_LINE = "Sem Linha",
  MANUALLY_SELECTED_LINE_PRE = "Seleção linhas pré",
  PRE_LINE_SEARCH_FIFO = "Linha Pré FIFO"
}

export enum ServiceCategoryTypeEnum {
  MOBILE_LINE = "MOBILE_LINE",
  BROADBAND = "BROADBAND",
  TRACKER = "TRACKER",
  TAG = "TAG"
}

export enum OperationInternalName {
  STANDARD_NEW_LINE = "STANDARD_NEW_LINE",
  FIXED_BROADBAND_ACTIVATION = "FIXED_BROADBAND_ACTIVATION",
  TAG_ACTIVATION = "TAG_ACTIVATION",
  TRACKER_NEW_LINE = "TRACKER_NEW_LINE",
  STANDARD_RENEWAL = "STANDARD_RENEWAL",
  STANDARD_PORTABILITY = "STANDARD_PORTABILITY",
  STANDARD_OWNERSHIP_TRANSFER = "STANDARD_OWNERSHIP_TRANSFER",
  TRAVEL_PREPAID = "TRAVEL_PREPAID",
  STANDARD_PREPAID = "STANDARD_PREPAID",
  TAG_PLAN_CHANGE = "TAG_PLAN_CHANGE",
  PABX_ACTIVATION = "PABX_ACTIVATION",
  PABX_RENEWAL = "PABX_RENEWAL",
  PABX_PORTABILITY = "PABX_PORTABILITY",
  BROADBAND_RENEWAL = "BROADBAND_RENEWAL"
}
